import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import compose from 'recompose/compose';

import { NotificationStack } from 'react-notification';
import { NOTIFICATION_TYPES, hideNotification } from 'store/actions/notificationActions';

const NOTIFICATION_APPEAR_TIME_MS = 3000;

/*
 TODO :  리스트 화면에서 동작이 자연스럽지 않음.. 다른 Notification으로 교체 고려..
    가끔 메모리 leak관련 에러가 나타남 확인 필요
*/
class Notification extends Component {

    onDissmiss = (notificationId) => {
        this.props.hideNotification(notificationId);
    }

    _getActiveBarStyleForNotification = (index, style, notification) => {
     
        const customStyle = {};
        customStyle.bottom = `${2 + index * 4}rem`;
        customStyle.left = `auto`;
        customStyle.right = '1rem';

        return {
          ...style,
          ...customStyle
        };
    }

    _getBarStyleForNotification = (index, style, notification) => {
     
        const customStyle = {};
        customStyle.bottom = `${2 + index * 4}rem`;
        customStyle.left = `auto`;
        customStyle.right = '-100%';
        customStyle.zIndex = '1200';
     
        /* 성공 시 배경색상 변경
        if (notification._type === NOTIFICATION_TYPES.INFO) {
          customStyle.backgroundColor = '#40c57d';
        }
        */
     
        /* 성공 시 배경색상 변경
        if (notification._type === NOTIFICATION_TYPES.ERROR) {
          customStyle.backgroundColor = '#f14848';
        }
        */

        return {
          ...style,
          ...customStyle
        };
    }

    _createNotificationObject = ( message, type = NOTIFICATION_TYPES.INFO, key ) => {

        return {
            message: message,
            key: key,
            action: '확인',
            //onClick: () => this.onDissmiss(key),
            onClick: (notification, deactivate) => {
                deactivate();
                this.onDissmiss(notification.key);
            },
            _type: type
        };
    };

    render() {
        console.log("Notification >>>>>>>>>>>>>>>>>>>>> render ");
        const { notifications } = this.props;

        const notiArrs = notifications.map(noti => {
            return this._createNotificationObject(noti.message, noti.type, noti.key)
        });

        return (
            <div>
                <NotificationStack 
                    notifications={notiArrs}
                    dismissAfter={NOTIFICATION_APPEAR_TIME_MS}
                    onDismiss={notification => {
                        this.props.hideNotification(notification.key);
                    }}
                    activeBarStyleFactory={this._getActiveBarStyleForNotification}
                    barStyleFactory={this._getBarStyleForNotification}
                    //onClick={handleClickGlobal}  모든 notifications 에 같은 행동을 주려면 여기서 선언. 어니면 각각의 객체에 값을 넣어준다.
                />
            </div>
        );
    }

}

Notification.propTypes = {
    notifications: PropTypes.array.isRequired,
    hideNotification: PropTypes.func.isRequired,
};


const mapStateToProps = state => ({
    notifications: state.notifications
});

export default compose(
    //translate,
    connect(mapStateToProps, {
        hideNotification,
    })
)(Notification);
